<template>
  <div id="app">
    <transition-group name="fade" mode="out-in">
      <div v-if="!loadingScreen" key="content">
        <div
          class="flexi-sticky"
          :class="{ 'scrolled-down': !showHeader, 'scrolled-up': showHeader }"
        >
          <div class="flexi-sticky__wrapper">
            <div class="flexi-header">
              <flexi-header
                :style="isNavOpen ? toggleBurger : ''"
                :inputData="
                  isHome ? inputData.navigationPages : internalPageMenu
                "
                :isNavOpen="isNavOpen"
                :isMenuLinks="false"
                @toggle-burger="setBurger"
              >
                <template v-slot:logo>
                  <a @click="goToRoute('/')">
                    <span class="header-logo"></span>
                  </a>
                </template>
                <template v-slot:flexi-bar>
                  <flexi-bar
                    @toggle-burger="setBurger"
                    :inputData="inputData.navigationPages"
                    :isNavOpen="isNavOpen"
                  >
                    <template v-slot:link="{ value }">
                      <a
                        v-if="
                          value.name === 'Home' ||
                            value.name === 'Login' ||
                            value.name === 'Try Free'
                        "
                        :href="value.href"
                        :target="value.name !== 'Home' ? '_blank' : ''"
                      >
                        <span v-text="value.name" />
                      </a>
                      <span
                        v-else
                        v-text="value.name"
                        @click="scroll(value.href)"
                      />
                    </template>
                  </flexi-bar>
                </template>
              </flexi-header>
            </div>
            <div class="flexi-navigation">
              <flexi-nav
                :inputData="
                  isHome ? inputData.navigationPages : internalPageMenu
                "
              >
                <template v-slot:items="slotProps">
                  <span
                    :id="slotProps.inputData.id"
                    v-if="
                      slotProps.inputData.name === 'Home' ||
                        slotProps.inputData.name === 'Login' ||
                        slotProps.inputData.name === 'Try Free'
                    "
                    @click="
                      goToExternalPage(
                        slotProps.inputData.href,
                        slotProps.inputData.name
                      )
                    "
                    @mouseleave="isTooltip = false"
                    @mouseover="selectedTooltip(slotProps.inputData.id)"
                    v-text="slotProps.inputData.name"
                  />
                  <span
                    v-else
                    :id="slotProps.inputData.id"
                    v-text="slotProps.inputData.name"
                    @click="scroll(slotProps.inputData.href)"
                    @mouseleave="isTooltip = false"
                    @mouseover="selectedTooltip(slotProps.inputData.id)"
                  />
                  <flexi-tooltip
                    :id="'item__' + 'key' + slotProps.inputData.id"
                    v-show="
                      isTooltip && selectedTooltipKey === slotProps.inputData.id
                    "
                    :tooltip="slotProps.inputData.tooltip"
                  />
                </template>
              </flexi-nav>
            </div>
          </div>
        </div>
        <vue-page-transition name="overlay-up-down">
          <router-view />
        </vue-page-transition>

        <flexi-cookie :company="'IMGForce'" @clickedButton="goToRoute">
        </flexi-cookie>

        <flexi-footer :year="year" @clickedButton="goToRoute">
          <template v-slot:footer-bottom>
            <div class="footer__bottom">
              <div>
                <span>© {{ year }} Designed and powered by</span>
                <a class="action" href="https://akrinum.com" target="_blank"
                  >Akrinum OÜ</a
                >
              </div>
              <div>All Rights Reserved</div>
            </div>
          </template>
        </flexi-footer>
      </div>
      <flexi-splash v-else key="content2">
        <template v-slot:spinner>
          <semipolar-spinner
            :animation-duration="2000"
            :size="105"
            color="#fff"
            data-aos="fade-up"
            data-aos-delay="250"
            data-aos-duration="700"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-center"
          />
        </template>
      </flexi-splash>
    </transition-group>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { internalPageMenu } from "./static/data/internalPageMenu";
import FlexiTooltip from "./components/FlexiTooltip.vue";

export default {
  components: {
    FlexiTooltip
  },
  data() {
    return {
      internalPageMenu: internalPageMenu,
      isHome: true,
      isTooltip: false,
      selectedTooltipKey: null
    };
  },
  watch: {
    $route: {
      handler: function(newVal) {
        this.isHome = newVal.name === "home";
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters(["inputData", "isNavOpen", "loadingScreen", "year"]),
    toggleBurger() {
      return {
        "--position-header": "absolute",
        "--top-header": "35px"
      };
    }
  },
  mounted() {
    this.fetchData();
    this.setYear();
  },
  methods: {
    ...mapActions(["setBurger", "fetchData", "setYear"]),
    goToExternalPage(href, name) {
      if (name !== "Home") {
        window.open(href, "_blank");
      } else {
        window.open = href;
      }
    },
    selectedTooltip(index) {
      this.isTooltip = true;
      this.selectedTooltipKey = index;
    }
  }
};
</script>
<style lang="scss">
@import "assets/scss/application";
.overlay-left,
.overlay-right,
.overlay-top,
.overlay-bottom,
.overlay-up-down {
  background: rgba(36, 34, 138, 0.79) !important;
  z-index: 10003 !important;
}
</style>
